import { FileTextOutlined } from '@ant-design/icons';
import type { NavigationItemType } from "~/types/navigation";

export default {
    id: 'sales-orders',
    permission: 'sales.order.list',
    title: 'Webshop Narudžbe',
    icon: FileTextOutlined,
    type: 'item',
    url: '/sales-orders',
} satisfies NavigationItemType;
